// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   CircularProgress,
//   Stack,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import { motion, AnimatePresence } from "framer-motion";

// const loadingTexts = [
//   "💰 Pooling in PoolMoney...",
//   "🌍 Contributing to Pardna...",
//   "🤝 Joining the Committee...",
//   "✨ Gathering for ROSCA...",
//   "👫🏻 Partner time!",
//   "💸 Tanda-ing away!",
//   "💲 Saving with Susu...",
//   "🇨🇳 Hui-ing up the funds...",
//   "🇰🇷 Kye collection in progress...",
//   "🇮🇩 Arisan magic happening...",
//   "🇪🇬 Gam’eya time!",
//   "📦 Box Hand-ing it up...",
//   "🕒 It’s Meeting Turn time!",
//   "🐈‍⬛ Adding to the Kitty...",
//   "🏛️ Tontine-ing like pros...",
//   "🌟 Hagbad-ing the pot...",
// ];

// const Loader = () => {
//   const [index, setIndex] = useState(0);
//   const theme = useTheme();

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIndex((prevIndex) => (prevIndex + 1) % loadingTexts.length);
//     }, 2000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <Stack
//       minHeight="100vh"
//       width="100%"
//       alignItems="center"
//       justifyContent="center"
//       gap={"20px"}
//       bgcolor={"#4328E7"}
//       color={"#ffffff"}
//     >
//       <CircularProgress />
//       <Box sx={{position:"relative"}}>
//       <AnimatePresence>
//         <motion.div
//           key={index}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.5 }}
//         >
//           <Typography align="center" color={"#ffffff"} position={"absolute"} width={"max-content"} fontWeight={"500"} left={"50%"} sx={{transform:"translateX(-50%)"}}>
//             {loadingTexts[index]}
//           </Typography>
//         </motion.div>
//       </AnimatePresence>
//       </Box>
//     </Stack>
//   );
// };

// export default Loader;

export default function Loader() {
  return <></>;
}
